module.exports = __webpack_public_path__ + "static/media/cpam.8398c546.jpg";